<script>
import resourceSelect from '../../mixins/resourceSelect';

export default {
  mixins: [resourceSelect],

  data() {
    return {
      route: 'api.families.index',
      defaults: {
        trackBy: 'id',
        label: 'name',
        placeholder: 'Sélectionnez une famille',
      },
    };
  },
};
</script>